<template>
 <div class="w_content">
		<div class="women">
			<a href="#"><h4> </h4></a>
		
		     <div class="clearfix"></div>	
		</div>
        
        
		<!-- grids_of_4 -->
		<div class="grids_of_4">
		 
			<div class="clearfix"></div>
		</div>
		<div class="grids_of_4">
		 
			<div class="clearfix"></div>
		</div>
		<div class="grids_of_4">
		  
			<div class="clearfix"></div>
            
            
            
            
		</div>
		
        
        	<div class="grids_of_4">
		  
			<div class="clearfix"></div>
            
            
            
            
		</div>
		
		
		
		<!-- end grids_of_4 -->
		
		
	</div>
</template>

<script>
import axios from "axios";
export default {
  name: 'proxy',
 props:
 {
     hash: 
    {
     type: String,
      required: true
  }
 },
data()
{
    return {
        hashValue: null,
        searchResults: [],
        tokenPresence: false
    }
},
async mounted()
{
    this.hashValue = this.hash;

    //check presence of access token
     //check for token and redirect to dashboard
         let accessToken = localStorage.getItem("token");
       if(accessToken !== "noToken")
        {
           // alert(accessToken);
            this.tokenPresence = true;
            
        }
        else{
             this.tokenPresence = false;
        }
       

        if(accessToken !== null)
        {
           // alert(accessToken);
            this.tokenPresence = true;
            
        }
        else{
             this.tokenPresence = false;
        }

       
        if((accessToken != "noToken") && (this.tokenPresence == true))
        {
            this.$router.push("/timeawards/userDashboard");
        }

//fire axios request to verify hash then redirect to change password page

    if(this.hashValue != null)
    {
        let Response = await axios({
       method: "get",
       url: `https://time-person-mofe.herokuapp.com/api/passwordReset/${this.hashValue}`,
     });

    if(Response.data.status == "success")
    {
          this.$router.push(`/timeawards/changePassword/${this.hashValue}`);
    }
    else{
        alert("Invalid reset hash");
          this.$router.push('/timeawards/');
    }

    }
    else
    {
    alert("Invalid reset hash");
    this.$router.push('/timeawards/');
    }


},
methods:
{
    searchGraphql: async function()
    {
        //fire axios graphQl query using props
        //this.searchString
    },
    
	viewProfile: function(profileId)
	{
		this.$router.push(`/timeawards/profileView/awardee/${profileId}`);
	}
}
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

</style>
